import React from 'react';
import ClassifiedAdsPage from '../../../features/off-page/classified-ads/ClassifiedAdsPage';

interface ClassifiedAdsWrapperProps {
  onBack: () => void;
  darkMode: boolean;
}

export default function ClassifiedAdsWrapper({ onBack, darkMode }: ClassifiedAdsWrapperProps) {
  return <ClassifiedAdsPage onBack={onBack} darkMode={darkMode} />;
}
